import Layout from "components/layout";
import SubscriptionTemplate from "components/pages/assinatura/subscription_template";

import { resetScroll } from "utils/browser";
import { useMounted } from "hooks/react";
import Cookies from "js-cookie";

export default function SubscriptionPage(): JSX.Element {
  useMounted(() => {
    resetScroll();

    const urlParams = new URLSearchParams(window.location.search);
    const redirectTo = urlParams.get("redirectTo");
    if (!redirectTo) return;

    Cookies.set("subscriptionRedirectTo", redirectTo, { expires: 1 / 24 });
  });

  return (
    <Layout
      title="Planos"
      description="Compare nossos planos e escolha o que melhor se adapta a você. O Vstiba Total oferece acesso ilimitado a questões, 100 mensagens no Chat de Questões por dia e o Modo Prova exclusivo para o ENEM e vestibulares."
      canonical="/assinatura"
    >
      <main>
        <div className="container">
          <SubscriptionTemplate />
        </div>
      </main>
    </Layout>
  );
}
